import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const assessmentCaseService = {
  list: async () => {
    const response = await api.get('/assessment-cases');
    return response.data;
  },
  listByPatient: async (patientId) => {
    const response = await api.get(`/assessment-cases/patient/${patientId}`);
    return response.data;
  },
  create: async (data) => {
    const response = await api.post('/assessment-cases', data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await api.patch(`/assessment-cases/${id}`, data);
    return response.data;
  },
  addInstrument: async (id, instrument) => {
    const response = await api.post(`/assessment-cases/${id}/instruments`, instrument);
    return response.data;
  },
  recordScore: async (id, index, data) => {
    const response = await api.post(`/assessment-cases/${id}/instruments/${index}/score`, data);
    return response.data;
  },
  addTimeLog: async (id, data) => {
    const response = await api.post(`/assessment-cases/${id}/time-logs`, data);
    return response.data;
  },
};

export default assessmentCaseService;
